import _ from 'underscore';
import { DataSourceState } from '@bingads-webui-react/image-picker'; // eslint-disable-line
import { getVideoObjectFromInvestAssets } from '../../util/video-converter';

const ASSET_TYPE_VIDEOS = 2;

class InvestVideoDataSource {
  constructor(options) {
    this.currentData = [];

    this.investImageDataService = options.investImageDataService;
    this.currentSearchTerm = '';

    this.pageSize = 20;
  }

  subscribe(callback) {
    this.callback = callback;
  }

  unsubscribe() {
    this.callback = null;
  }

  excuteCallBackIfExsit(status) {
    if (this.callback) {
      this.callback(status);
    }
  }

  loadMore() {
    this.currentPage += 1;

    return this.fetchVideoAsync();
  }

  reload() {
    this.currentData = [];
    this.currentPage = 0;

    this.excuteCallBackIfExsit(DataSourceState.Done);

    return this.fetchVideoAsync();
  }

  searchAsync(searchTerm) {
    this.currentData = [];

    this.excuteCallBackIfExsit(DataSourceState.Done);

    if (searchTerm === null) {
      this.currentSearchTerm = '';
    } else {
      this.currentSearchTerm = searchTerm;
    }
    this.currentPage = 0;

    return this.fetchVideoAsync();
  }

  fetchVideoAsync() {
    this.excuteCallBackIfExsit(DataSourceState.Loading);

    const customQueries = {
      appName: 'CampaignUI',
      assetTypeId: ASSET_TYPE_VIDEOS,
      $skip: this.currentPage * this.pageSize,
      $top: this.pageSize,
    };

    if (this.currentSearchTerm) {
      customQueries.creativeId = this.currentSearchTerm;
    }

    return this.investImageDataService.getInvestAssets({ customQueries }).then((response) => {
      this.hasMore = response['@odata.count'] > _.get(response, ['value', 'length'], 0) + this.currentData.length;

      const moreData = _.map(response.value, getVideoObjectFromInvestAssets);
      this.currentData = this.currentData.concat(moreData);
    }).finally(() => {
      this.excuteCallBackIfExsit(DataSourceState.Done);
    });
  }

  getData() {
    return { hasMore: this.hasMore, data: this.currentData };
  }

  saveVideoAsync(options) {
    return this.investImageDataService.addInvestVideoAsset(options);
  }
}

const initializeInvestVideoDataSource = ({
  investImageDataService,
}) => {
  const investVideoDataSource = new InvestVideoDataSource({
    investImageDataService,
  });

  return investVideoDataSource;
};

export { InvestVideoDataSource, initializeInvestVideoDataSource };
